import React, { useRef, useEffect, useState } from "react";
import MeetingFooter from "../MeetingFooter/MeetingFooter.component";
import Participants from "../Participants/Participants.component";
import "./MainScreen.css";
import { connect } from "react-redux";
import { setMainStream, updateUser } from "../../store/actioncreator";
import { Button, Offcanvas } from "react-bootstrap"
// import VideoControlPanel from "../../../Components/VideoControl/VideoControlPanel";

import { roomId } from "../../server/firebase"






const MainScreen = (props) => {


  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  // const handleShow = () => {
  //   window.location.assign(`https://videoadmin.hellosuperstars.com?管理员密钥=${props.roomId}`)
  //   // window.location.href = ;
  // };







  const participantRef = useRef(props.participants);



  const onMicClick = (micEnabled) => {
    if (props.stream) {
      props.stream.getAudioTracks()[0].enabled = micEnabled;
      props.updateUser({ audio: micEnabled });
    }
  };
  const onVideoClick = (videoEnabled) => {
    if (props.stream) {
      props.stream.getVideoTracks()[0].enabled = videoEnabled;
      props.updateUser({ video: videoEnabled });
    }
  };

  useEffect(() => {
    participantRef.current = props.participants;
  }, [props.participants]);

  const updateStream = (stream) => {
    for (let key in participantRef.current) {
      const sender = participantRef.current[key];
      if (sender.currentUser) continue;
      const peerConnection = sender.peerConnection
        .getSenders()
        .find((s) => (s.track ? s.track.kind === "video" : false));
      peerConnection.replaceTrack(stream.getVideoTracks()[0]);
    }
    props.setMainStream(stream);
  };

  const onScreenShareEnd = async () => {
    const localStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });

    localStream.getVideoTracks()[0].enabled = Object.values(
      props.currentUser
    )[0].video;

    updateStream(localStream);

    props.updateUser({ screen: false });
  };

  const onScreenClick = async () => {
    let mediaStream;
    if (navigator.getDisplayMedia) {
      mediaStream = await navigator.getDisplayMedia({ video: true });
    } else if (navigator.mediaDevices.getDisplayMedia) {
      mediaStream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });
    } else {
      mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { mediaSource: "screen" },
      });
    }

    mediaStream.getVideoTracks()[0].onended = onScreenShareEnd;

    updateStream(mediaStream);

    props.updateUser({ screen: true });
  };
  return (
    <>
      <div className="wrapper" >
        {/* <h2 className="text-center text-warning">Learning Session</h2> */}

        <div className="main-screen">
          <Participants />
        </div>

        <div className="footer">
          <MeetingFooter

            roomId={props.roomId}
            onScreenClick={onScreenClick}
            onMicClick={onMicClick}
            onVideoClick={onVideoClick}
          />
        </div>
        {/* <VideoControlPanel /> */}

        {/* <Offcanvas show={show} placement="end" onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Participants list </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body> */}
        {/* 
            <VideoControlPanel room_id={roomId} /> */}
        {/* </Offcanvas.Body>
        </Offcanvas> */}
      </div>
    </>

  );
};

const mapStateToProps = (state) => {
  return {
    stream: state.mainStream,
    participants: state.participants,
    currentUser: state.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainStream: (stream) => dispatch(setMainStream(stream)),
    updateUser: (user) => dispatch(updateUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);
